import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e28ef0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoring-days__block" }

import { PropType } from 'vue';
import { MonitoringDaysTable } from './components';
import { MonitoringHeaderFilterModel } from '../models';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-days',
  props: {
  /**Фильтр мониторинга */
  filter: { type: Object as PropType<MonitoringHeaderFilterModel> },
  /**Начальная дата */
  selectDateStart: { type: Date },
  /**Конечная дата */
  selectDateEnd: { type: Date },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MonitoringDaysTable), {
      class: "monitoring-days__table",
      filter: __props.filter,
      selectDateStart: __props.selectDateStart,
      selectDateEnd: __props.selectDateEnd,
      selectPerformer: __props.filter.SelectedPerformer,
      onGetTotalWorkTime: _cache[0] || (_cache[0] = ($event: any) => (__props.filter.TotalWorkTime = $event))
    }, null, 8, ["filter", "selectDateStart", "selectDateEnd", "selectPerformer"])
  ]))
}
}

})